// extracted by mini-css-extract-plugin
export default {"root":"App_root__yaMIC","header":"App_header__uR-nQ","navigation":"App_navigation__M4KQE","content":"App_content__nV5bJ"};